import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_FEATURE_TOGGLES_DATA: createAsyncActionConstants('FETCH_FEATURE_TOGGLES_DATA'),
}